import {Generics, verticalPage} from "./generics.ts";
import {create} from "../../fjsc/src/f2.ts";

export class Gallery {
    static page() {
        return Generics.pageFrame(
            true,
            verticalPage(
                create("h1")
                    .classes("flex-v")
                    .text("Gallery")
                    .build(),
            )
        )
    }
}